import type { ReactNode } from 'react';

export interface FilterOption {
  label: string;
  value: string;
}

export interface FilterGroupConfig {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

interface FilterControlsProps {
  groups: FilterGroupConfig[];
  onReset?: () => void;
  showReset?: boolean;
  children?: ReactNode;
}

export function FilterControls({ groups, onReset, showReset, children }: FilterControlsProps) {
  return (
    <div className="divide-y divide-background-200">
      {groups.map((group) => (
        <div key={group.label} className="flex flex-col gap-2 py-3 sm:flex-row sm:items-start sm:gap-4">
          <span className="w-16 shrink-0 pt-1.5 font-label text-xs font-medium text-foreground-500">
            {group.label}
          </span>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = option.value === group.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => group.onChange(option.value)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                    active
                      ? 'bg-primary-500 font-medium text-background-50'
                      : 'border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      {(showReset || children) && (
        <div className="flex flex-wrap items-center justify-between gap-3 pt-3">
          <div>{children}</div>
          {showReset && onReset && (
            <button
              type="button"
              onClick={onReset}
              className="flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1.5 font-label text-xs text-foreground-500 transition-colors hover:text-primary-600"
            >
              <i className="ri-restart-line text-[13px]"></i>
              重置筛选
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export function SortTabs({
  options,
  value,
  onChange,
}: {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 font-label text-xs transition-colors ${
            value === option.value
              ? 'bg-secondary-500 font-medium text-background-50'
              : 'text-foreground-600 hover:text-foreground-950'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}